import React from 'react';

const Excel = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="128"
    height="128"
    viewBox="0 0 128 128"
  >
    <path
      d="M70.5 107.5l-12.8-2.2-36.2-6c-2.2-.4-3-1.2-3-3.6v-64c0-2 .7-2.7 2.6-3l48-8c1-.2 1 0 2 0v86.8zM35.2 48.8c1.8 4.4 3.5 8.4 5.3 12.3.8 2 .7 3 0 5l-6 12h3.3c2 1 2.8 0 3.4-2l3.5-8.2 4 10c.3.5.8 1.3 1.4 1.4 2 .4 4 .4 6 .6L49 65c-.6-1.4-.6-2.4 0-3.7 2-4 3.8-8 5.6-12 .3-.4.4-1 .6-1.6h-2.7c-2.2-.3-3.4.6-4 2.8-1 2.8-2.2 5.4-3.6 8.7l-4-9c0-.7-1-1.5-1.6-1.5-1.6-.2-3 0-5 0zm37.6 48.5v-6h12.8v-8.7H72.8v-3h13V71h-13v-3h13v-8.7h-13v-3h13v-8.7h-13v-2.8h12.8v-9H73v-5h2c10.6 0 21 0 31.7-.2 2 0 2.8.6 2.8 2.8V95c0 2-.6 3-2.7 3h-32c-.6 0-1.2 0-2-.3zm16-53h14.5v-8.6H89v8.5zM89 56h14.5v-8.5H88.8V56zm0 11.7h14.5v-8.5H88.8v8.5zm0 11.7h14.4V71H89v8.4zm0 11.8h14.4v-8.5H88.8v8.5z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#1E7045"
    />
  </svg>
);

export default Excel;
